import React, { useState, useEffect, useReducer } from 'react';
import Product from '../custom_elements/Product';
import ErrorMessage from '../custom_elements/ErrorMessage';
import SearchDataForm from './SearchDataForm';
import RepresentativeCase from '../custom_elements/RepresentativeCase';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const ProductList = ({onBerechnenButton, onButtonClick, passedRequestData}) => {
  const [products, setProducts] = useState([]);
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const [passedRequestDataState, setPassedRequestDataState] = useState(passedRequestData);
  const [borderState, setBorderState] = useState({ color: '', visible: false });

  const toggleContactForm = (chosen_product) => {
    onButtonClick(chosen_product);
  };

  const representativeExample = {
      kreditbetrag: 200000,
      rate: 1218.76,
      laufzeit: 240,
      sollzins: 3.950,
      effzins: 4.141,
      fixlaufzeit: 0,
      zinsges: 92593.55,
      rueckges: 292593.55,
      institut: "Test",
      description: "Test"
  };

  const backendUrl = process.env.REACT_APP_DOMAIN_BACKEND; // Get domain from environment variable

  const handleBerechnenClick = (data) => {
      // Merge data from localStorage into current form data
      let mergedData = { ...data }; // start with the passed data

      try {
          const local = localStorage.getItem('anfangsFormData');
          if (local) {
              const localData = JSON.parse(local);
              for (const [key, value] of Object.entries(localData)) {
                  // Only set if not already present or empty/0
                  if (!mergedData[key] || mergedData[key] === "" || mergedData[key] === "0") {
                      if (key === 'kaufpreis') mergedData['k_erwerb'] = value;
                      else if (key === 'eigenmittel') mergedData['em'] = value;
                      else mergedData[key] = value;
                  }
              }
          }
      } catch (err) {
          console.error("Error merging localStorage data:", err);
      }

      // Save merged data to state
      setPassedRequestDataState(mergedData);

      // Optional: also store it back to localStorage
      localStorage.setItem('anfangsFormData', JSON.stringify(mergedData));

      // Trigger parent callback
      onBerechnenButton(mergedData);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = `${backendUrl}/ajaxController.php?action=getKreditProdukte`;

        const response = await axios.post(apiUrl, passedRequestDataState);

        console.log("IN fetchData useEffect");
        console.log(passedRequestDataState);
        
        if (response.data && Array.isArray(response.data)) {
          setProducts(response.data);
          setBorderState({ color: 'green', visible: true });
        } else {
          setProducts([]);
          setBorderState({ color: 'red', visible: true });

        }
      } catch (error) {
        setProducts([]);
          setBorderState({ color: 'red', visible: true });

        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [passedRequestDataState]);

  useEffect(() => {
    if (borderState.visible) {
      const timer = setTimeout(() => {
        setBorderState((prevState) => ({ ...prevState, visible: false, color: "transparent" }));
    }, 1000); // Border will fade out after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [borderState]);

  return (
    <div className="product-list">
      <div className="list-header">
        <h1>IHR WEG ZUM WOHNTRAUM</h1>
        <div className="headerChecks">
          <FontAwesomeIcon style={{paddingRight:10}} icon={faCheckCircle} />
          <span>Unabhängig und kostenfrei</span>
        </div>
        <div className="headerChecks">
          <FontAwesomeIcon style={{paddingRight:10}} icon={faCheckCircle} />
          <span>Nur wenige Klicks zum besten Angebot</span>
        </div>
        <div className="headerChecks">
          <FontAwesomeIcon style={{paddingRight:10}} icon={faCheckCircle} />
          <span>Vergleiche österreichische Banken und Sparkassen</span>
        </div>

      </div>
      <div className={`form-container ${borderState.visible ? 'visible' : ''}`} style={{ borderColor: borderState.color }}>
       <SearchDataForm className="search-data-form" onBerechnenButton={handleBerechnenClick} requestData={passedRequestDataState} />
     </div>
     <br />
      {/* Map through products and render each Product component */}
      {!products[0] ? <ErrorMessage></ErrorMessage>:""}
      {products.map((product, index) => (
        <div key={index} className="mb-4">
          {/* Pass product data as props to Product component */}
          <Product onAngebotButtonClick={toggleContactForm} product={product} />
        </div>
      ))}
      <hr />
      <RepresentativeCase product={representativeExample}/>

    </div>
  );
};

export default ProductList;
